/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { memo, useCallback, useContext } from "react";
import Actions from "./Actions/Actions";
import Conditions from "./Conditions/Conditions";
import Context from "../../../store/context";

function ListenerRule({ ruleState, setRule, event }) {
  const { isModalSidebar } = useContext(Context);
  const dispatch = useCallback(
    (action) => {
      switch (action.type) {
        case "ruleLabel":
          setRule({
            ...ruleState,
            Label: action.label,
          });
          break;
        case "edit-actions":
          setRule({
            ...ruleState,
            Actions: action.data,
          });
          break;
        case "edit-conditions":
          setRule({
            ...ruleState,
            Conditions: action.data,
          });
          break;
        case "createContact":
          setRule({
            ...ruleState,
            createContact: {
              ...ruleState.createContact,
              [action.field]: action.value,
            },
          });
          break;
        default:
      }
    },
    [ruleState, setRule]
  );

  const setConditions = useCallback(
    (data) => dispatch({ type: "edit-conditions", data }),
    [dispatch]
  );

  const setActions = useCallback(
    (data) => dispatch({ type: "edit-actions", data }),
    [dispatch]
  );

  return (
    <div className="form-group">
      <div className="row mb-4">
        <div className={isModalSidebar ? "col-12" : "col-xl-2"}>Label</div>
        <div className={isModalSidebar ? "col-12" : "col-xl-10"}>
          <input
            type="text"
            className="form-control rule-label"
            value={ruleState.Label}
            onChange={(e) =>
              dispatch({
                type: "ruleLabel",
                ruleId: ruleState.UUID,
                label: e.target.value,
              })
            }
          />
        </div>
      </div>

      <Conditions
        ruleState={ruleState}
        setConditions={setConditions}
        event={event}
      />

      <Actions event={event} ruleState={ruleState} setActions={setActions} />
    </div>
  );
}

export default memo(ListenerRule);
